(ns frontend.ag-grid
  (:require
   ["ag-grid-community" :refer [ModuleRegistry provideGlobalGridOptions] :as ag-community]
   ["ag-grid-enterprise" :refer [AllEnterpriseModule LicenseManager] :as ag-enterprise]
   [frontend.db :as db]
   [oops.core :as oops]))

(defn init
  [license-key]
  (let [license-key (or "Using_this_{AG_Grid}_Enterprise_key_{AG-064071}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Zapflow_Oy}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Zapflow}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Zapflow}_need_to_be_licensed___{Zapflow}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{26_September_2025}____[v3]_[01]_MTc1ODg0MTIwMDAwMA==cdee722d4f81602de586e3f92bfdc16a"
                        (get @db/app-state :ag-grid-license-key license-key))]
    ;; Set the license key
    (oops/ocall LicenseManager "setLicenseKey" license-key)

    ;; Register all enterprise features
    (.registerModules ModuleRegistry #js [AllEnterpriseModule])

    ;; Mark all grids as using legacy themes
    #_(provideGlobalGridOptions #js {:theme "legacy"})))
